export const iconSize = {
  tiny: 16,
  medium: 24,
  large: 48,
  huge: 64,
}

export type IconSize = keyof typeof iconSize
